import { gsap } from 'gsap/all'

export const initInputs = () => {
  const inputs = [...document.querySelectorAll('.js-input')]
  if (inputs.length <= 0) { return false }

  new Inputs(inputs)
}

class Inputs {
  constructor (inputs) {
    this.inputs = []

    inputs.forEach(input => {
      this.inputs.push({
        element: input,
        line: input.parentElement.querySelector('.js-line')
      })
    })

    this.init()
  }

  show (input) {
    gsap.to(input.line, 0.5, {
      scaleX: 1,
      ease: 'power4.out',
      onComplete: () => {
        input.line.style.transformOrigin = 'right'
      }
    })
  }

  hide (input) {
    gsap.to(input.line, 0.5, {
      scaleX: 0,
      ease: 'power4.out',
      onComplete: () => {
        input.line.style.transformOrigin = 'left'
      }
    })
  }

  init () {
    this.inputs.forEach(input => {
      input.element.addEventListener('focus', () => {
        this.show(input)
      })

      input.element.addEventListener('blur', () => {
        this.hide(input)
      })
    })
  }
}
